import { ITooltipParams } from 'ag-grid-enterprise';
import {
  add,
  eachMonthOfInterval,
  endOfMonth,
  format,
  getMonth,
  startOfMonth,
} from "date-fns";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useGetFilterData } from '../../../../../..//VectorFlow/Services/MTO/Common/CommonFilter';
import SafeLottie from "../../../../../../components/commons/SafeLottie";
import MTOActionToolBar from "../../../../../../components/VectorFLOW/commons/MTO/ActionToolBar/MTOActionToolBar";
import VFModalCard from "../../../../../../components/VectorFLOW/commons/VFModalCard";
import { useUserData } from "../../../../../../context/index";
import { notifyError, notifySuccess } from '../../../../../../helpers/notify';
import { DownloadExcel, formatFilterJSON, getBodyForExcelExport, getColumnDefinations } from "../../../../../../helpers/utils";
import useColDef from '../../../../../../hooks/useColDef';
import useFilter from '../../../../../../hooks/useFilter';
import SwipePointer from "../../../../../../lottie/swipe pointer.json";
import { DAYWISE_COVERAGE_ANALYTICS } from "../../../../../../redux/actions/MTO";
import { useGetUIConfigData } from "../../../../../../VectorFlow/Services/MTO/Common/UIConfig";
import {
  useGetUserUIConfigData,
  useUpdateUserUIConfigData,
} from "../../../../../../VectorFlow/Services/MTO/Common/UserUIConfig";
import { useGetDayWiseCoverageData } from "../../../../../../VectorFlow/Services/MTO/Procurement/DayWiseCoverage";
import BomExcelModal from '../../../Common/BomExcelModal';
import ColorCellRenderer from "../../../Common/ColorCellRenderer/ColorCellRenderer";
import { FilterPageName, pagination, UIGridCode } from "../../../Common/Enum";
import OverlayLoader from "../../../Common/Loader";
import MaterialRequirementComponent from "../../MaterialRequirement/MaterialRequirementComponent";
import useMaterialReq from "../../MaterialRequirement/useMaterialRequirements";
import DayWiseCoverageCalender from "./DayWiseCoverageCalender";
import DayWiseCoverageHeader from "./DayWiseCoverageHeader";
import DayWiseCoverageTable from "./DayWiseCoverageTable";
import { AnimationWrapper, HelperText, TableContainer } from "./style.css";

enum Colors {
  Selected = "#B93B7E",
  NoData = "lightgrey",
  Green = "#33800B",
  Red = "#F02424",
}

const APIFilterConfig = {
    filSecVisConfig: {
        "Proc_Day_Wise_Coverage" : {
            mjr : false,
            or: false,
            res: true,
            cus: true
        },
    }
  };

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const DayWiseCoverage = () => {
    const minDate = useMemo(() => startOfMonth(add(new Date(), { months: -2 })), [])
    const maxDate = useMemo(() => endOfMonth(new Date()), []);

  const [startDate, setStartDate] = useState(format(minDate, "yyyy-MM"));
  const [endDate, setEndDate] = useState(format(maxDate, "yyyy-MM"));
  const [selectedDate, setSelectedDate] = useState<string>("");
  const [showModal, setShowModal] = useState<boolean>(false);

  const [calenderData, setCalenderData] = useState<any>();

    const [loading, setLoading] = useState(false);
    const [currentGridRef, setCurrentGridRef] = useState<any>(null);
    const [columnState, setColumnState] = useState<any>([]);
    const [isReset, setIsReset] = useState(false);
    const [colDef, setColDef] = useState([]);
    const [childColDef, setChildColDef] = useState([]);
    const [filterData, setFilterData] = useState({});
    const { mutateAsync: updateUserUIReportConfigData, isLoading: isUpdateUserConfig } = useUpdateUserUIConfigData();
    const { mutateAsync: getUserUIReportConfigData, isLoading: isGetUserConfig } = useGetUserUIConfigData();
    const { mutateAsync: getData, isLoading: isCalenderLoading } = useGetDayWiseCoverageData();
    const { mutateAsync: getUIConfigData } = useGetUIConfigData();
    const [masterUIConfig, setMasterUIConfig] = useState([]);
    const { colDefMap, getColDef } = useColDef()



    const [userPageSize, setUserPageSize] = useState<number>(pagination.mtoPageSize); 
    const [userConfigFetched, setUserConfigFetched] = useState(false); 
    const [showExcelModal, setShowExcelModal] = useState(false);

    const { mutateAsync: getPageWiseFilterData, /*isLoading*/ } = useGetFilterData()
    const { 
        state: currFilter, 
        setState: setCurrFilter, 
        onFilterRemove, 
        isFilterOpen, 
        isMfgSelected,
        onAddFilter, 
        onApplyFilter, 
        toggleFilter,
        appliedFilters
    } = useFilter(filterData, APIFilterConfig.filSecVisConfig.Proc_Day_Wise_Coverage);
    const { user } = useUserData();
    const reportName = "DayWiseCoverage";

  const themeUi = user?.user?.theme_ui;

  const getCalenderData = async () => {
    const data = await getData({
      startDate: format(startOfMonth(startDate), "yyyy-MM-dd"),
      endDate: format(endOfMonth(endDate), "yyyy-MM-dd"),
    });
    setCalenderData(data?.data?.data);
  };

  const dispatch = useDispatch();

  useEffect(() => {
    getCalenderData();
  }, [startDate, endDate]);

  const setDateRange = (start: string, end: string) => {
    setStartDate(start);
    setEndDate(end);
  };

  const getColor = (id: string) => {
    if (!calenderData?.[id]) {
      return Colors.NoData;
    }
    if (id === selectedDate) {
      return Colors.Selected;
    }
    return calenderData?.[id]?.oc === calenderData?.[id]?.fk
      ? Colors.Green
      : Colors.Red;
  };

  const getToolTipContent = (id: string) => {
    if (!calenderData?.[id]) {
      return null;
    }
    return (
      <table
        style={{
          padding: "6px",
          display: "table",
          width: "150px",
          fontSize: "11px",
        }}
      >
        <thead>
          <tr>
            <td
              colSpan={2}
              style={{ borderBottom: "1px dashed white", paddingRight: "4rem" }}
            >
              Details
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>No of Orders</td>
            <td>{calenderData?.[id]?.oc}</td>
          </tr>
          <tr>
            <td>Full kit</td>
            <td>{calenderData?.[id]?.fk}</td>
          </tr>
          <tr>
            <td>Partial kit</td>
            <td>{calenderData?.[id]?.pk}</td>
          </tr>
          <tr>
            <td>No kit</td>
            <td>{calenderData?.[id]?.nk}</td>
          </tr>
        </tbody>
      </table>
    );
  };

  useEffect(() => {
    getAnalytics();
  }, [calenderData]);

  useEffect(() => {
    setLoading(isCalenderLoading);
  }, [isCalenderLoading]);

  const formatNumber = (number: number) =>
    number % 1 !== 0 ? Math.round(number * 100) / 100 : number;

  const getAnalytics = () => {
    if (calenderData) {
      const analytics: any = {};
      const monthRange = eachMonthOfInterval({
        start: startDate,
        end: endDate,
      });
      monthRange.forEach((date: any) => {
        analytics[getMonth(date)] = {
          green: 0,
          red: 0,
        };
      });
      Object.entries(calenderData).forEach((entry: any) => {
        const releasedDate = entry[0];
        // console.log(releasedDate,getColor(releasedDate) === Colors.Red)
        // const month = format(releasedDate, "MMM");
        const month = getMonth(releasedDate);
        const isGreen = getColor(releasedDate) === Colors.Green;
        let countOfGreen = analytics[month].green;
        let countOfRed = analytics[month].red;
        if (isGreen) {
          countOfGreen += 1;
        } else {
          countOfRed += 1;
        }
        analytics[month] = {
          green: countOfGreen,
          red: countOfRed,
        };
      });

      const data = Object.entries(analytics).map((entry: any) => {
        const greens = entry[1].green;
        const reds = entry[1].red;
        return [
          months[entry[0]],
          greens,
          reds,
          formatNumber((greens / (greens + reds)) * 100 || 0),
        ];
      });

      dispatch(DAYWISE_COVERAGE_ANALYTICS(data));
    }
  };

  const {
    renderView,
    toggleCurrentTab,
    date,
    currentTab,
    isMatReqDayWiseLoading,
    isMatReqLoading,
  } = useMaterialReq(null, selectedDate);

    useEffect(() => {
        toggleCurrentTab({
            id: 'sdv',
            label: 'Selected Day View',
            value: 'sdv'
        })
       

    }, [selectedDate])

    useEffect(()=>{
        if(selectedDate && selectedDate.length && currentGridRef){
          if(!masterUIConfig.length)
            setColumnDef();
        }
    },[currentGridRef])

  const colDefCustomizations = {
    ColorPriority: {
      cellRenderer: (params: any) => {
        if (params.node.group) {
          return null;
        }
        return ColorCellRenderer(params);
      },
    },
    Status: {
      hide: true,
      rowGroup: true,
    },
  };

    const childColDefCustomizations = {
      MRQ: {
        cellStyle: {
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
        },
        tooltipValueGetter: (params: ITooltipParams) => { return `Missing RM Quantity: ${params.value}` },
        cellRenderer: (params: any) => {
            const format = new Intl.NumberFormat('en', {
                notation: 'compact',
                compactDisplay: 'short',
              });
          return (
            
            <div
              style={{
                borderRadius: "50%",
                background:
                  params.data.rmq == params.data.rmal ? "#33800B" : "#E53F3F",
                width: "30px",
                height: "30px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "1.6rem",
                color: "white",
                fontSize: "0.9rem",
              }}
            >
              {format.format(params.value)}
            </div>
          );
        },
      },
    };

    const setColumnDef = useCallback(async () => {
        try {
            const childResponse = await getUIConfigData("DayWiseCoverageChild");
          const response = await getUIConfigData(reportName);
          getColDef(response);
          setChildColDef(getColumnDefinations(childResponse.data.data,childColDefCustomizations))
          setColDef(getColumnDefinations(response.data.data, colDefCustomizations))
        }
        catch (e) {
          console.log(e);
        }
    },[])

   const getUserColumnConfig = async () => {
        try {
            const data = await getUserUIReportConfigData({
                un: user.user.name,
                rn_id: UIGridCode.ProcDayWiseCov
            });

            const configData = data?.data?.data[0]?.columns_settings ? JSON.parse(data?.data?.data[0]?.columns_settings) : {};
            
            // Extract column state
            const newColState = configData.cs || []; 
            // Extract page size (fallback to default if not found)
            const savedPageSize = configData.pageSize ? Number(configData.pageSize) : pagination.mtoPageSize;

            setColumnState(newColState);
            setUserPageSize(savedPageSize);
            setUserConfigFetched(true); // Mark as fetched

            if (!data) {
                console.error('Failed to apply column state');
            }
        } catch (error) {
            console.error(error);
        }
    }
    
    useEffect(() => {
        if (colDef?.length && currentGridRef?.current) {
            
          setMasterUIConfig(currentGridRef?.current.api.getColumnState());
          
        }
      }, [colDef,currentGridRef]);

  useEffect(() => {
    if (masterUIConfig && masterUIConfig.length) {
      getUserColumnConfig();
    }
  }, [masterUIConfig]);


    const handleSaveClick = async (coldefs?: any, newPageSize?: number) => {
        try {
            // Determine what to save
            const currentCS = coldefs || currentGridRef?.current?.api.getColumnState() || [];
            const currentSize = newPageSize || userPageSize;
            const isPivot = currentGridRef?.current?.api.isPivotMode();


            // Construct the full config object
            const fullConfig = {
                cs: currentCS,
                pageSize: currentSize,
                pivotMode: isPivot
            };

            const payload = {
                un: user.user.name,
                rn_id: UIGridCode.ProcDayWiseCov,
                cs: JSON.stringify(fullConfig), // Save the whole object
            };
            
            await updateUserUIReportConfigData([payload]);
            
            // Update local state
            if(coldefs) setColumnState(coldefs);
            if(newPageSize) setUserPageSize(newPageSize);

        } catch (error) {
            console.error(error);
        }
    }
    const onPageSizeChange = (newSize: number) => {
        handleSaveClick(undefined, newSize); // Trigger save immediately
    }

  const handleResetClick = () => {
    setIsReset(true);
  };

    useEffect(() => {
        if (isReset) {
          handleSaveClick(masterUIConfig); 
          setIsReset(false);
        }
      }, [isReset]);

  const handleMaterialRequirementClick = () => {
    setShowModal(true);
  };

    const getFilterData = async () => {
    try {
        const response = await getPageWiseFilterData({page_name: FilterPageName.Proc_Day_Wise_Coverage});
        setFilterData(response?.data.data);
    } catch (error) {
        console.error(error);
    }
    }

      useEffect(() => {
        getFilterData();
      }, []);


      // --- Excel Export Logic ---

    const ExcelExport =()=>{
        currentGridRef?.current?.api?.exportDataAsExcel({ fileName: `Day_Wise_Coverage` , sheetName: 'Day Wise Coverage'});
      }

    const executeExcelExport = async (isChildren = 0) => {
        try {
            const headersdata = currentGridRef?.current?.api.getColumnState();
            const formattedFilters = formatFilterJSON(appliedFilters);

            const body = getBodyForExcelExport({
                headersdata: headersdata, filterData: formattedFilters, colDefMap: colDefMap
            });


            const excelResponse = await getData({
                startDate: format(startOfMonth(startDate), "yyyy-MM-dd"),
                endDate: format(endOfMonth(endDate), "yyyy-MM-dd"),
                plannedReleaseDate: selectedDate,
                isExcelExport: 1,
                body,
                report_name: FilterPageName.Proc_Day_Wise_Coverage,
                isChildren: isChildren
            });

            if (excelResponse?.status === 200) {
                DownloadExcel(excelResponse, "Day_Wise_Coverage_Report");
                notifySuccess("Excel exported successfully!");
            } else {
                notifyError("Failed to export Excel ");
            }
        } catch (error) {
            console.error("Excel Export Error:", error);
            notifyError("An error occurred during export");
        }
    };


    const handleExportClick = (isChildren = 0) => {
      const columnState = currentGridRef?.current?.api?.getColumnState() || [];
      
      const groupedColumnsCount = columnState.filter((col:any) => col.rowGroup).length;

      if (groupedColumnsCount > 1) {
          ExcelExport();
      } else {
          executeExcelExport(isChildren);
      }
  };

const onExcelExportClick = () => {
        const columnState = currentGridRef?.current?.api?.getColumnState() || [];
        const groupedColumnsCount = columnState.filter((col:any) => col.rowGroup).length;

        if (groupedColumnsCount > 1) {
            ExcelExport();
        } else {
            setShowExcelModal(true);
        }
    };

    const handleExcelConfirm = () => {
        setShowExcelModal(false);
        handleExportClick(1);
    };

    const handleExcelCancel = () => {
        setShowExcelModal(false);
       handleExportClick(0);
    };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div>
        <MTOActionToolBar
          isExcelExport
          themeUi={themeUi}
          isAddFilterButton
          isFilterOpen={isFilterOpen}
          onAddFilter={onAddFilter}
          toggleFilter={toggleFilter}
          onApplyFilter={onApplyFilter}
          multiFilter={currFilter}
          setMultiFilter={setCurrFilter}
          onFilterRemove={onFilterRemove}
          isMfgSelected={isMfgSelected}
          onExcelExportClick={onExcelExportClick}
          handleSaveClick={() => handleSaveClick()}
          handleResetClick={handleResetClick}
        />
      </div>
          
      <DayWiseCoverageHeader
        max={maxDate}
        min={minDate}
        startDate={startDate}
        endDate={endDate}
        setDateRange={setDateRange}
      />
      {(loading || isUpdateUserConfig || isGetUserConfig) && <OverlayLoader />}
      <DayWiseCoverageCalender
        start={startDate}
        end={endDate}
        getToolTipContent={getToolTipContent}
        getColor={getColor}
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
      />
      <div className={TableContainer}>
        {calenderData?.[selectedDate] ? (
          <DayWiseCoverageTable
            columnState={columnState}
            setCurrentGridRef={setCurrentGridRef}
            colDef={colDef}
            currentGridRef={currentGridRef}
            setLoading={setLoading}
            startDate={format(startOfMonth(startDate), "yyyy-MM-dd")}
            endDate={format(endOfMonth(endDate), "yyyy-MM-dd")}
            selectedDate={selectedDate}
            appliedFilters={appliedFilters}
            childColDef={childColDef}

                        userPageSize={userPageSize}
                        onSavePageSize={onPageSizeChange}
                        configLoaded={userConfigFetched}
          />
        ) : (
          <div className={AnimationWrapper}>
            <SafeLottie
              src={SwipePointer}
              loop
              autoplay
              style={{ height: 100, width: 100 }}
            />

            <div className={HelperText}>
              Please select the <strong>Dates</strong> from above to view{" "}
              <strong>Order lists</strong>
            </div>
          </div>
        )}
      </div>
      <VFModalCard
        openModal={showModal}
        closeModal={() => {
          setShowModal(false);
        }}
        headerText={"Material Coverage"}
        headerIcon={""}
        closeIcon={"/assets/img/VectorFLOW/NMS/close-dark.svg"}
        paddingLeftAndRight={0}
        headerTextColor={"black"}
        backgroundColor={"f4f4f4"}
      >
        <div
          style={{
            position: "relative",
            margin: "2rem",
            overflow: "auto",
            width: "80vw",
            height: "70vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <MaterialRequirementComponent
            renderView={renderView}
            currentTab={currentTab}
            date={date}
            toggleCurrentTab={toggleCurrentTab}
          />
          {(isMatReqDayWiseLoading || isMatReqLoading) && <OverlayLoader />}
        </div>
      </VFModalCard>
      {calenderData?.[selectedDate] && (
        <div
          style={{
            marginBottom: "1rem",
            marginTop: "-1rem",
            fontSize: "18px",
            fontWeight: "bold",
            cursor: "pointer",
            paddingTop: "1rem",
            display: "flex",
            alignItems: "center",
            gap: "1rem",
          }}
          onClick={handleMaterialRequirementClick}
        >
          Material Requirement
          <svg
            id="Layer_2"
            data-name="Layer 2"
            xmlns="http://www.w3.org/2000/svg"
            width="15.917"
            height="15.917"
            viewBox="0 0 15.917 15.917"
          >
            <path
              id="Path_10654"
              data-name="Path 10654"
              d="M16.194,8.959a.724.724,0,0,0-.724.724v4.341a1.447,1.447,0,0,1-1.447,1.447H3.894a1.447,1.447,0,0,1-1.447-1.447V3.894A1.447,1.447,0,0,1,3.894,2.447H8.235A.724.724,0,0,0,8.235,1H3.894A2.894,2.894,0,0,0,1,3.894V14.023a2.894,2.894,0,0,0,2.894,2.894H14.023a2.894,2.894,0,0,0,2.894-2.894V9.682A.723.723,0,0,0,16.194,8.959Z"
              transform="translate(-1 -1)"
              fill="#b93b7e"
            />
            <path
              id="Path_10655"
              data-name="Path 10655"
              d="M19.9,1.444a.716.716,0,0,0-.135-.2c-.009-.009-.012-.022-.021-.031s-.022-.012-.031-.021A.679.679,0,0,0,19.235,1H14.894a.724.724,0,0,0,0,1.447h2.594L12.212,7.723a.723.723,0,1,0,1.023,1.023L18.512,3.47V6.064a.724.724,0,1,0,1.447,0V1.723a.716.716,0,0,0-.056-.279Z"
              transform="translate(-4.041 -1)"
              fill="#b93b7e"
            />
          </svg>
            
              <BomExcelModal
                open={showExcelModal}
                onClose={() => setShowExcelModal(false)}
                onConfirm={handleExcelConfirm}
                onCancel={handleExcelCancel}
                themeUi={themeUi}
                headerText={"Excel Export"}
                messageText={"Do you want to download Excel with BOM Data?"}
            />
        </div>
      )}
    </div>
  );
};

export default DayWiseCoverage;
